function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY
import * as React from 'react';
export default function FlagSL(props) {
  return /*#__PURE__*/React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURfX19fz8/BqE1xZ9zyy5QxJ4yC/BRzLHSjPLTTXOTv26ANoAAAEbSURBVDjL3YwxbsMwDEWpG8g3MKILGCa8ZxAyBxC8ewikNZOcsVs6du1t+0nFjtMk7hIURZ+oz0/q2/S5zge9r/P2c2A8nc7n8SHycqRxnSOlPKYEl/WKK00k54xAzCmCpDfHqYmklAaKBbznGK+hiTnwjIF2Sw43RGy2EvAyqUJ2XkSRYSDv/cHP7LQWbMmv84pAtY79EwFbWVsZFekGS5hKPJbWkjGmNGu/O30jBY5IVnCEVhwWJSWvZKSs0bxVX8w/YbNO/RsBt2lxoK1TRVuUqwnCDuvrZaninWuImZFQvdyWuZRQE9/TTgb55lFgSUOBOw4BtmMOsDrKHKS6hvoLIfRyusWR7Z46Ad/0/V0C+34//+EJLwh8ASlUNKl6yfZiAAAAAElFTkSuQmCC",
    alt: "SL"
  }, props));
}